import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    SimpleChanges,
    OnChanges,
    ViewChild
} from '@angular/core';
import {IntegrationServices} from '../../../../shared/services/src/api';
import {StringUtils} from '../../../../shared';
import {ValidatorUtils} from '../../../../shared/utils/src/validator.utils';
@Component({
    selector: 'freshdesk-rule-component',
    templateUrl: './freshdesk-rule.component.html'
})

export class FreshdeskRuleComponent implements OnInit, OnDestroy, OnChanges  {
    // 현재 freshdesk 쓸거냐
    @Input() detailRuleUseFlag: any;

    @Input() set nowItgrCallbackInfo(value: any) {
        this.setNowItgrCallbackInfo(value);
    }

    // 상위 컴포넌트에서 이거 수정가능한지 설정해줄 때 쓰는 변수
    @Input() public isEditable: boolean;
    @Input() public itgrNo: number;

    @ViewChild('eventRuleSet') eventRuleSet: any;

    _nowItgrCallBackInfo: any;

    public itgrCallbackInfo = {
        itgrAttrs: [],
        ruleInfo: []
    };

    public freshdeskConfig: any = {
        url: '',
        urlAttrNo: '',
        apiKey: '',
        apiKeyAttrNo: ''
    };

    // ruleInfo
    ruleInfo: any;

    // ruleInfo 중 IRTY10 인 경우
    eventRuleInfo = {
        itgrApplRuleNo: '',
        useYn: 'Y',
        itgrRuleTypeCd: 'IRTY10',
        ruleCnfgInfo: []
    };
    eventRuleCnfgInfo = [];
    eventRuleUseFlag = true;

    isEmptyURL = false;
    isInvalidURL = false;
    isEmptyApiKey = false;

    constructor(private _integrationServices: IntegrationServices) {
    }

    ngOnInit() {
        if (typeof this._nowItgrCallBackInfo !== 'undefined'
            && this._nowItgrCallBackInfo.hasOwnProperty('itgrAttrs')) {
            this.setConfig(this._nowItgrCallBackInfo);
        }
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
        const useFlag = changes['detailRuleUseFlag'];
        if (useFlag && useFlag.currentValue === true) {
            this.eventRuleUseFlag =  true;
        }
        const chng = changes['nowItgrCallbackInfo'];
        if (chng && this._nowItgrCallBackInfo.hasOwnProperty('itgrAttrs')) {
            this.setConfig(this._nowItgrCallBackInfo);
        }
    }

    getItgrCallbackInfo() {
        this.itgrCallbackInfo.itgrAttrs = [{
            attrNm : 'URL',
            attrVal : this.freshdeskConfig.url
        }, {
            attrNm : 'API_KEY',
            attrVal : this.freshdeskConfig.apiKey
        }];
        if (this.eventRuleUseFlag) {
            this.itgrCallbackInfo.ruleInfo.push(this.eventRuleSet.getRuleInfo('IRTY10'));
        }
        return this.itgrCallbackInfo;
    }

    setNowItgrCallbackInfo(data) {
        if (typeof data !== 'undefined' && Object.keys(data).length > 0) {
            this._nowItgrCallBackInfo = data;
            this.ruleInfo = this._nowItgrCallBackInfo.ruleInfo;

            for (const rule of this.ruleInfo) {
                this.setUseRule(rule);
            }
        } else {
            this._nowItgrCallBackInfo = [];
        }
    }

    setUseRule(rule) {
        this.eventRuleInfo = rule;
        const ruleType = rule.itgrRuleTypeCd;
        switch (ruleType) {
            case 'IRTY10':
                this.eventRuleCnfgInfo = rule.ruleCnfgInfo;
                this.detailRuleUseFlag = rule['useYn'] === 'Y';
                for (const ruleCnfg of this.eventRuleCnfgInfo) {
                    ruleCnfg.itgrRuleTypeCd = ruleType;
                }
        }
    }

    public setConfig(info) {
        const itgrAttrs = info['itgrAttrs'];
        const ruleInfo = info['ruleInfo'];

        for (const itgrAttr of itgrAttrs) {
            const attrNm = itgrAttr['attrNm'];
            const attrVal = itgrAttr['attrVal'];
            const itgrApplInstlAttrNo = itgrAttr['itgrApplInstlAttrNo'];

            switch (attrNm) {
                case 'URL':
                    this.freshdeskConfig.urlAttrNo = itgrApplInstlAttrNo;
                    this.freshdeskConfig.url = attrVal;
                    this.isEmptyURL = false;
                    this.isInvalidURL = false;
                    break;
                case 'API_KEY':
                    this.freshdeskConfig.apiKeyAttrNo = itgrApplInstlAttrNo;
                    this.freshdeskConfig.apiKey = attrVal;
                    this.isEmptyApiKey = false;
                    break;
            }
        }

        for (const rule of ruleInfo) {
            this.setUseRule(rule);
        }
    }

    public updateConfig(detailUseFlag: boolean) {
        const itgrCallbackInfo = {
            'itgrAttrs': [],
            'ruleInfo': []
        };

        // 아예 상세설정을 사용하지 않을 때
        if (!detailUseFlag) {
            const validRuleInfo = (typeof  this.ruleInfo !== 'undefined' && this.ruleInfo.length > 0);
            if (validRuleInfo) {
                for (const rule of this.ruleInfo) {
                    const newRule = {
                        itgrApplRuleNo: rule['itgrApplRuleNo'],
                        useYn: 'N'
                    };
                    itgrCallbackInfo.ruleInfo.push(newRule);
                }
            }

            return itgrCallbackInfo;
        }

        // 상세 설정을 사용할 때
        itgrCallbackInfo.itgrAttrs = [{
            itgrApplInstlAttrNo : this.freshdeskConfig.urlAttrNo,
            attrNm : 'URL',
            attrVal : this.freshdeskConfig.url
        },  {
            itgrApplInstlAttrNo : this.freshdeskConfig.apiKeyAttrNo,
            attrNm : 'API_KEY',
            attrVal : this.freshdeskConfig.apiKey
        }];

        if (this.eventRuleUseFlag) {
            const eventRule = {
                itgrApplRuleNo: this.eventRuleInfo.itgrApplRuleNo,
                useYn: 'Y',
                itgrRuleTypeCd: this.eventRuleInfo.itgrRuleTypeCd,
                ruleCnfgInfo: this.eventRuleSet.getEventRuleConfigInfo()
            };
            itgrCallbackInfo.ruleInfo.push(eventRule);
        }

        // 추가 룰이 생성된다면 if문 + flag로

        return itgrCallbackInfo;
    }

    validChk(id) {
        let _isValid = true;
        switch (id) {
            case 'url':
                if (StringUtils.isEmpty(this.freshdeskConfig.url)) {
                    this.isEmptyURL = true;
                    this.isInvalidURL = false;
                    _isValid = false;
                } else if (!ValidatorUtils.checkURL(this.freshdeskConfig.url)) {
                    this.isEmptyURL = false;
                    this.isInvalidURL = true;
                    _isValid = false;
                } else {
                    this.isEmptyURL = false;
                    this.isInvalidURL = false;
                    _isValid = true;
                }
                break;
            case 'apiKey':
                if (StringUtils.isEmpty(this.freshdeskConfig.apiKey)) {
                    this.isEmptyApiKey = true;
                    _isValid = false;
                }  else {
                    this.isEmptyApiKey = false;
                }
                break;
        }
        return _isValid;
    }

    public validation(): boolean {
        let isValid = true;
        for (const key in this.freshdeskConfig) {
            if (!this.validChk(key)) {
                isValid = false;
                break;
            }
        }
        if (!this.eventRuleSet.isValidSelectData()) {
            isValid = false;
        }
        return isValid;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/detail-rule/freshdesk-rule/freshdesk-rule.component.ts